import { Table } from '@octano/global-ui';
import { useOffersColumns } from '../hooks/useOffersColumns';
import { Col, Collapse, Row } from 'reactstrap';
import { Offer, Process, Subprocess } from '../types';
import { useCallback, useState } from 'react';
import OffersListEditModal from './OffersListEditModal';

interface Props {
  isOpen: boolean;
  data?: Subprocess[];
  process: Process;
}

export default function OffersList({ isOpen, data, process }: Props) {
  const [openEditOffers, setOpenEditOffers] = useState<{
    offer?: Offer;
    open: boolean;
  }>({ open: false });

  const toggleEditOffers = useCallback(
    (offer?: Offer) => {
      setOpenEditOffers({ offer, open: !openEditOffers.open });
    },
    [openEditOffers.open],
  );

  const columns = useOffersColumns({
    toggleEditOffers,
    process,
  });

  return (
    <Row>
      <Col xs={12} className="mt-5">
        <Collapse isOpen={isOpen} contentClassName="pt-4 text-center">
          <Table columns={columns} data={data ?? []} striped />
        </Collapse>
      </Col>
      {openEditOffers.open && (
        <OffersListEditModal
          toggle={toggleEditOffers}
          offer={openEditOffers.offer as Offer}
          process={process}
        />
      )}
    </Row>
  );
}
